<template>
  <div>
    <p class="cm-mg-p-wzd">1. {{ $t('common_words.general_information2') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-12 col-md-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="..."
          @click="
            handleClickOnCode(
              'M Cultivos',
              {
                index: 'code',
                customField: false,
              },
              model.route
            )
          "
        >
        </fg-input>
      </div>
      <div class="col-12 col-md-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.crop')}: *`"
          v-model="model.name"
          name="common_words.crop"
          v-validate="modelValidations.crop"
          :error="getError('common_words.crop', true)"
          :placeholder="$t('common_words.banana')"
        ></fg-input>
      </div>
      <div class="col-12 col-md-4">
        <fg-input
          type="text"
          :label="`${$t('diseases.scientific_name')}:`"
          v-model="model.scientific_name"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-md-2">
        <fg-input
          :precision="2"
          :step="0.01"
          :max="10"
          type="number"
          :label="`${$t('common_words.coefficient')}: `"
          v-model="model.coefficient"
          name="coeficiente"
          placeholder="1.1"
        ></fg-input>
      </div>
      <div class="col-12 col-md-2">
        <fg-input
          type="number"
          :label="`${$t('common_words.weighing_count')}: *`"
          v-model="model.weighing_count"
          name="coeficiente"
          placeholder="1"
        ></fg-input>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label>{{ $t('diseases.use_section') }}</label>
          <el-switch
            v-model="model.use_section"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-12">
        <select-businesses-component
          ref="select-businesses"
          :showLoading="true"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';

export default {
  data() {
    return {
      model: {
        code: null,
        id: null,
        name: null,
        coefficient: null,
        weighing_count: null,
        businesses_id: [],
        businesses_names: [],
        scientific_name: '',
        use_section: false,
      },
      modelValidations: {
        crop: {
          required: true,
        },
        code: {
          required: true,
        },
      },
      businesses: null,
      marketers: null,
    };
  },
  mixins: [MixinForm, MixinLoading, MixinPermissions],
  methods: {
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', this.model);
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;
          if (!isset(this.model.businesses_id)) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }
            return false;
          } else return true;
        });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const {
        id,
        name,
        coefficient,
        weighing_count,
        code,
        scientific_name,
        use_section,
      } = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        id,
        name,
        coefficient,
        weighing_count,
        code,
        scientific_name,
        use_section,
      };
      this.$set(
        this.model,
        'use_section',
        use_section === true || use_section === 1 || use_section === '1'
      );
    }
  },
};
</script>
<style></style>
